import {useId} from '@mantine/hooks';
import React, {useRef} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import useOnMount from 'ui-library/hooks/useOnMount';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface PopupProps {
  closeable: boolean;
  title: string;
}

function Popup({closeable, title}: PopupProps): JSX.Element {
  const id = useId();
  const ref = useRef<HTMLDivElement>(null);
  useOnMount(() => {
    ref.current?.focus();
  });
  return (
    <div
      className="modal-dialog popup"
      role="dialog"
      aria-labelledby={id}
      aria-modal="true"
      ref={ref}
      {...getTestProps({component: 'PopupTemplate', element: 'root'})}
    >
      <div className="modal-content">
        <div className="modal-header">
          {closeable && (
            <button type="button" data-dismiss="modal" aria-hidden="true" className="close">
              &times;
            </button>
          )}
          <h4
            className="modal-title"
            // oxlint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{__html: title}}
            id={id}
          />
        </div>
        <div className="modal-body" />
        <div className="modal-footer" />
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<PopupProps>(Popup);
